export const ACTION_LINK_TYPE = 1
export const PUBLIC_PORTAL_LINK_TYPE = 2
export const PREFERENCE_PAGE_LINK_TYPE = 3
